import { useQuery } from '@tanstack/react-query';
import { NotificationsRequests } from 'src/requests/notifications.requests';
import { QueryKey, queryRetry } from 'src/utils/react-query';

export function useNotificationsQuery() {
  const { data, isLoading, refetch } = useQuery(
    [QueryKey.NOTIFICATIONS],
    NotificationsRequests.getNotifications,
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchInterval: 1000 * 60 * 1,
      retry: queryRetry,
    },
  );

  return {
    notifications: data?.notifications || [],
    unreadCount: data?.unreadCount || 0,
    count: data?.count || 0,
    isNotificationsLoading: isLoading,
    refetchNotifications: refetch,
  };
}
